import { ActionReducerMap } from '@ngrx/store';
import { countryReducer } from './master-data/country.reducer';
import { plantReducer } from './master-data/plant.reducer';
import { regionReducer } from './master-data/region.reducer';
import { supplierReducer } from './master-data/supplier.reducer';
import { priceSheetReducer } from './master-data/price.sheet.reducer';
import { AppState } from '../states/app.state';
import { busLineReducer } from './master-data/busline.reducer';
import { vehicleReducer } from './master-data/vehicle.reducer';
import { busLineStopReducer } from './master-data/bus-line-stop.reducer';
import { busCheckReducer } from './bus-check-list.reducer';

export const reducers: ActionReducerMap<AppState> = {
    countries: countryReducer,
    plants: plantReducer,
    regions: regionReducer,
    suppliers: supplierReducer,
    busLines: busLineReducer,
    vehicles: vehicleReducer,
    busLineStops: busLineStopReducer,
    priceSheets: priceSheetReducer,
    busChecks: busCheckReducer
};
